import { GeometryIcon } from "react-migration/layouts/map/Ownership/icons";
import { LayerTypeSelectionHeaderProps } from "../../../types";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import { useDesignationById } from "react-migration/domains/constraints/designation/hooks/useDesignationById";

export function OwnershipDesignationSelectionHeader({ selection }: Readonly<LayerTypeSelectionHeaderProps>) {
  const { t } = useTranslation();
  const { designation } = useDesignationById(selection.id);

  return (
    <div className="flex flex-row items-start gap-x-2">
      <div>
        <GeometryIcon />
      </div>
      <div className="flex flex-col items-start grow">
        <div className="text-xs font-semibold text-text-base-tertiary">{t("selection.ownership_title")}</div>
        <div className="text-sm font-semibold text-text-base-primary">{designation?.display_name}</div>
      </div>
    </div>
  );
}
